const context = "despesas";
const abrev = "des";

const empresas = [
    {
        path: '/des/empresa',
        name: 'des-empresa',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/empresa/EmpresaRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'des-empresa-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/empresa/EmpresaList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'des-empresa-new',
                        meta: { contexto: context, abrev: abrev },
                        redirect: { name: 'des-empresa-dados-cadastrais-new' },
                        component: () => import('@/components/vendas/empresa/EmpresaManage.vue'),
                        children: [
                            {
                                path: 'dados-cadastrais',
                                name: 'des-empresa-dados-cadastrais-new',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/empresa/AbaDadosCadastrais.vue')
                            }
                        ]
                    },
                    {
                        path: 'edit/:id',
                        name: 'des-empresa-edit',
                        meta: { contexto: context, abrev: abrev },
                        redirect: { name: 'des-empresa-dados-cadastrais-edit' },
                        component: () => import('@/components/vendas/empresa/EmpresaManage.vue'),
                        children: [
                            {
                                path: 'dados-cadastrais',
                                name: 'des-empresa-dados-cadastrais-edit',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/empresa/AbaDadosCadastrais.vue')
                            }
                        ]
                    },
                ]
            },
        ]
    },
    {
        path: '/des/empresa/turno',
        name: 'des-turno',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/turno/TurnoRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'des-turno-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/turno/TurnoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'des-turno-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/turno/TurnoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'des-turno-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/turno/TurnoManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/des/empresas/feriado',
        name: `des-feriado`,
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/feriado/FeriadoRoute.vue'),
        children: [
            {
                path: 'list',
                name: `des-feriados-list`,
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/feriado/FeriadoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: `des-feriados-new`,
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/feriado/FeriadoManager.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: `des-feriados-edit`,
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/feriado/FeriadoManager.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/des/empresa/moeda',
        name: 'des-moeda',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/moeda/Moeda.vue'),
        children: [
            {
                path: 'list',
                name: 'des-moeda-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/moeda/MoedaList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'des-moeda-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/moeda/MoedaManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'des-moeda-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/moeda/MoedaManage.vue')
                    },
                ]
            },
        ]
    },
];

export default [
    { // COCKPIT
        path: '/des/cockpit',
        name: 'des-cockpit',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/cockpit/CockpitDespesas.vue')
    },

    {
        path: '/des/motivo-despesa',
        name: 'des-motivo-despesa',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/despesas/motivoDespesa/MotivoDespesa.vue'),
        children: [
            {
                path: 'list',
                name: 'des-motivo-despesa-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/despesas/motivoDespesa/MotivoDespesaList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'des-motivo-despesa-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/despesas/motivoDespesa/MotivoDespesaManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'des-motivo-despesa-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/despesas/motivoDespesa/MotivoDespesaManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/des/acertos',
        name: 'des-acertos',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/despesas/acertos/Acertos.vue')
    },
    {
        path: '/des/lista/acertos/:userId/:situacaoId',
        name: 'des-lista-acertos',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/despesas/acertos/Acerto.vue')
    },

    {
        path: '/des/adiantamentos',
        name: 'des-adiantamentos',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/despesas/adiantamentos/Adiantamentos.vue'),
        children: [
            {
                path: 'list',
                name: 'des-adiantamentos-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/despesas/adiantamentos/AdiantamentosList.vue')
            },
            {
                path: 'new',
                name: 'des-adiantamentos-new',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/despesas/adiantamentos/AdiantamentosManage.vue')
            },
            {
                path: 'view/:id',
                name: 'des-adiantamentos-view',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/despesas/adiantamentos/AdiantamentosView.vue')
            },
        ]
    },
    {
        path: '/des/tipo-veiculo',
        name: 'des-tipo-veiculo',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/despesas/tipoVeiculo/TipoVeiculo.vue'),
        children: [
            {
                path: 'list',
                name: 'des-tipo-veiculo-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/despesas/tipoVeiculo/TipoVeiculoList.vue')
            },
            {
                path: 'new',
                name: 'des-tipo-veiculo-new',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/despesas/tipoVeiculo/TipoVeiculoManage.vue')
            },
            {
                path: 'edit/:id',
                name: 'des-tipo-veiculo-edit',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/despesas/tipoVeiculo/TipoVeiculoManage.vue')
            },
        ]
    },
    // @85859 - Tela refatorada
    {
        path: '/des/despesa',
        name: 'des-despesa',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/despesas/despesas/Despesa.vue'),
        children: [
            {
                path: 'list',
                name: 'des-despesa-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/despesas/despesas/DespesaList'),
                children: [
                    {
                        path: 'new',
                        name: 'des-despesa-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/despesas/despesas/DespesaManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'des-despesa-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/despesas/despesas/DespesaManage')
                    },
                ]
            },
        ]
    },
    {
        path: '/des/valor-km',
        name: 'des-valor-km',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/despesas/valorKm/ValorKm.vue'),
        children: [
            {
                path: 'list',
                name: 'des-valor-km-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/despesas/valorKm/ValorKmList.vue')
            },
            {
                path: 'new',
                name: 'des-valor-km-new',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/despesas/valorKm/ValorKmManage.vue')
            },
        ]
    },
    {
        path: '/des/configurar-recibos',
        name: 'des-configurar-recibos',
        component: () => import('@/components/despesas/configurarRecibo/ConfigurarRecibos.vue'),
        children: [
            {
                path: 'list',
                name: 'des-configurar-recibos-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/despesas/configurarRecibo/ConfigurarRecibosList'),
                children: [
                    {
                        path: 'new',
                        name: 'des-configurar-recibos-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/despesas/configurarRecibo/ConfigurarRecibosManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'des-configurar-recibos-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/despesas/configurarRecibo/ConfigurarRecibosManage')
                    },
                ]
            },
        ]
    },
    {
        path: '/des/despesa-automatica',
        name: 'des-despesa-automatica',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/despesas/despesaAutomatica/DespesaAutomatica')
    },
    {
        path: '/des/critica-despesa',
        name: 'des-critica-despesa',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/despesas/criticas/CriticaDespesa'),
        children: [
            {
                path: 'list',
                name: 'des-critica-despesa-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/despesas/criticas/CriticaDespesaList')
            },
            {
                path: ':id/:data',
                name: 'des-edit-critica-despesas',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/despesas/criticas/CriticaDespesaManage')
            },
            {
                path: 'empresa/usr-id/:usuarioid',
                name: 'des-edit-critica-despesas-empresa',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/despesas/criticas/CriticaDespesasSemEmpresa')
            },
        ]
    },
    {
        path: '/des/relatorio-lancamentos',
        name: 'des-relatorio-lancamentos',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/despesas/relatorios/Lancamentos'),
        children: [
            {
                path: 'list',
                name: 'des-relatorio-lancamentos-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/despesas/relatorios/LancamentosList')
            },
            {
                path: 'view/:id',
                name: 'des-relatorio-lancamentos-view',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/despesas/relatorios/LancamentosView.vue')
            },
        ]
    },
    {
        path: '/des/relatorio-km-automatico',
        name: 'des-relatorio-km-automatico',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/despesas/relatorios/KmAutomatico'),
        children: [
            {
                path: 'list',
                name: 'des-relatorio-km-automatico-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/despesas/relatorios/KmAutomaticoList')
            },
            {
                path: 'view/:id',
                name: 'des-relatorio-km-automatico-view',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/despesas/relatorios/KmAutomaticoView.vue')
            },
        ]
    },
    {
        path: '/des/cadastros/centro-custo',
        name: 'des-centro-custo',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/financeiro/centro-custo/CentroCusto.vue'),
        children: [
            {
                path: 'list',
                name: 'des-centro-custo-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/financeiro/centro-custo/CentroCustoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'des-centro-custo-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/financeiro/centro-custo/CentroCustoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'des-centro-custo-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/financeiro/centro-custo/CentroCustoManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/des/cadastros/motivo',
        name: 'des-motivo',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/motivo/Motivo'),
        children: [
            {
                path: 'list',
                name: 'des-motivo-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/motivo/MotivoList'),
                children: [
                    {
                        path: 'new',
                        name: 'des-motivo-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/motivo/MotivoManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'des-motivo-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/motivo/MotivoManage')
                    }
                ]
            },
        ]
    },
    {
        path: '/des/cadastros/forma-pagamento',
        name: 'des-forma-pagamento',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/despesas/forma-pagamento/FormaPagamentoRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'des-forma-pagamento-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/despesas/forma-pagamento/FormaPagamentoListRoute.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'des-forma-pagamento-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/despesas/forma-pagamento/FormaPagamentoManageRoute.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'des-forma-pagamento-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/despesas/forma-pagamento/FormaPagamentoManageRoute.vue')
                    }
                ]
            },
        ]
    },
    {
        path: '/des/prestacao-contas',
        name: 'des-acerto-despesa',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/despesas/acerto-despesa/AcertoDespesa.vue'),
        children: [
            {
                path: 'list',
                name: 'des-acerto-despesa-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/despesas/acerto-despesa/AcertoDespesaList'),
                children: [
                    {
                        path: 'new',
                        name: 'des-acerto-despesa-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/despesas/acerto-despesa/AcertoDespesaManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'des-acerto-despesa-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/despesas/acerto-despesa/AcertoDespesaManage'),
                        children: [
                            {
                                path: 'new/:uuid',
                                name: 'des-acerto-despesa-item-new',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/despesas/acerto-despesa/abas/despesas/AcertoDespesaItemManage.vue')
                            },
                            {
                                path: 'edit/:iditem',
                                name: 'des-acerto-despesa-item-edit',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/despesas/acerto-despesa/abas/despesas/AcertoDespesaItemManage.vue')
                            },
                        ]
                    },
                ]
            },
        ]
    },
    ...empresas
];